export interface IDirectorySearchParams {
    priority?: boolean;
    owner?: string;
    search?: string;
}

export enum SearchParamActionTypes {
    SET_SEARCH_PARAM = "SET_SEARCH_PARAM",
}
